module.exports = __webpack_public_path__ + "static/media/BackendIcon.2b3e783e.svg";